// @flow

export default (input: string): string => input.replace(/<[^>]+>/ig, '');
